'use strict';

var _ = require('lodash');
var DataService = function DataService($q, dataProcessingService, dataRetrievalService) {
  function retrieveDataFor(source, cacheRawData, screenModeConfig) {
    return dataRetrievalService.retrieveData(source.url, source.rsqlQuery, source.sortBy, source.sortOrder, source.pageLimit, cacheRawData, source.requestParameters, source.threadsQuantity, source.dynamicPageLimit, source.httpMethod, source.mimeType, source.ignoredErrorStatuses, screenModeConfig, source.maxLimit, source.softLimit, source.multiRequestAllowed);
  }
  function getData(sourceType, targetType, filters, metricsKeys, dataSources, cacheRawData, metricDescriptor, screenModeConfig) {
    var dataPromises = [];
    if (!dataProcessingService.hasCachedData(dataSources, sourceType, targetType, metricsKeys, metricDescriptor)) {
      _.forEach(dataSources, function (dataSource) {
        dataPromises.push(retrieveDataFor(dataSource, cacheRawData, screenModeConfig));
      });
    }
    var processor = dataProcessingService.getProcessor(dataSources, filters, metricsKeys, sourceType, targetType, metricDescriptor);
    return $q.all(dataPromises).then(processReceivedData).then(processor);
  }
  function clearCache() {
    dataProcessingService.invalidateTransformationCache();
    dataRetrievalService.invalidateRawCache();
  }

  /**
   * Create a data object based on the array returned by $q.all.
   * @returns {{domain: *, target: *}}
   * @param responses
   */
  function processReceivedData(responses) {
    function mergePages(pagedResponse) {
      var key = _.findKey(pagedResponse[0], _.isArray);
      var merged = Array.prototype.concat.apply([], _.map(pagedResponse, key));
      return _.extend({}, pagedResponse[0], _.set({}, key, merged));
    }
    function isPagedResponse(response) {
      return _.isArray(response) && _.get(response, ['0', 'searchCriteria']);
    }
    var mergedResponses = _.map(responses, function (response) {
      return isPagedResponse(response) ? mergePages(response) : response;
    });
    return {
      domain: mergedResponses[0],
      secondDomain: mergedResponses[1],
      thirdDomain: mergedResponses[2]
    };
  }
  return {
    getData: getData,
    clearCache: clearCache
  };
};
DataService.$inject = ['$q', 'DataProcessingService', 'DataRetrievalService'];
module.exports = DataService;